import { PaginationState } from '@tanstack/react-table';
import { isEqual, parseInt } from 'lodash';
import { createParser } from 'nuqs';

import { DEFAULT_PAGINATION } from '@/lib/constants';

export const parseAsPagination = createParser<PaginationState>({
  parse(value) {
    // eg: page=1 or page=1:20 for a non-default page size
    const [pageIndex, pageSize] = value.split(':');
    const index = parseInt(pageIndex) - 1;
    if (pageSize) {
      return { pageIndex: index, pageSize: parseInt(pageSize) };
    }
    return { pageIndex: index, pageSize: DEFAULT_PAGINATION.pageSize };
  },
  serialize(value) {
    const pageIndex = `${value.pageIndex + 1}`;
    if (value.pageSize !== DEFAULT_PAGINATION.pageSize) {
      return `${pageIndex}:${value.pageSize}`;
    }

    return pageIndex;
  },
  eq: isEqual,
});
